import React from 'react';

import { StyledFallback, StyledSpinner } from './RouteFallback.styles';

/**
 * Shown while a lazily-loaded route chunk arrives. Deliberately quiet — a skeleton
 * pretending to be the Studio would be more distracting than a moment of stillness.
 */
const RouteFallback = () => (
  <StyledFallback role="status" aria-label="Loading">
    <StyledSpinner />
  </StyledFallback>
);

export default RouteFallback;
